import { Autocomplete, TextField, Tooltip } from "@mui/material";
import { dcContent } from "../../services/content";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Controller } from "react-hook-form";
import { googleMapsInput } from "src/styles/globalStyles";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Image from "next/image";
import { useState } from "react";
import { useGoogleMapScript } from "../hooks/useGoogleMapScript";

export function MuiInput({
  label,
  inputStrings,
  defaultValue,
  errors,
  register,
  onChange,
  type,
  control,
  existing,
  actDroner,
  allEquipment,
}: {
  label?: string;
  inputStrings: any;
  defaultValue?: string | undefined;
  errors?: any;
  register?: any;
  onChange: (text: string) => void;
  type?: string;
  control?: any;
  existing?: boolean;
  actDroner?: any;
  allEquipment?: any;
}) {
  const [showPassword, setShowPassword] = useState(false);
  useGoogleMapScript();

  return (
    <div
      className={`settingsInput ${
        type === "location" ? "customizedMuiPlaceInput" : ""
      }`}
    >
      {label && (
        <div className="settingsInput__label">
          <label className="settings__secondaryText">{label}</label>
          <Tooltip
            title={inputStrings.tooltip}
            sx={{ width: "12px", height: "12px", marginLeft: "-4px" }}
          >
            <InfoOutlinedIcon />
          </Tooltip>
        </div>
      )}

      {!type && (
        <div className="settingsInput__wrapper">
          <TextField
            multiline={inputStrings.multiline}
            type={showPassword ? "text" : inputStrings.type}
            id={inputStrings.id}
            defaultValue={defaultValue}
            // @ts-ignore
            helperText={errors[inputStrings.id]?.message}
            error={!!errors[inputStrings.id]}
            {...register(inputStrings.id, {
              required: {
                value: inputStrings.required,
                message: inputStrings.requiredErrorMessage,
              },
              min: {
                value: inputStrings.minValue,
                message: inputStrings.rangeErrorMessage,
              },
              max: {
                value: inputStrings.maxValue,
                message: inputStrings.rangeErrorMessage,
              },
              maxLength: {
                value: inputStrings.maxLength,
                message: inputStrings.maxLengthErrorMessage,
              },
              minLength: {
                value: inputStrings.minLength,
                message: inputStrings.minLengthErrorMessage,
              },
              pattern: {
                value: inputStrings.pattern,
                message: inputStrings.patternErrorMessage,
              },
            })}
            onChange={(e) => onChange(e.target.value)}
            className="settingsInput__input"
          />
          {inputStrings.type === "number" && (
            <h4 className="settingsInput__wrapper--text">km</h4>
          )}
          {label?.includes("password") && (
            <div className="settingsInput__wrapper--helper">
              <Image
                width={23.5}
                height="15"
                src="/assets/eyeIcon.png"
                alt="eye icon"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          )}
        </div>
      )}

      {type === "location" && (
        <Controller
          rules={{
            required: inputStrings.required,
          }}
          render={({ field, fieldState }) => (
            <>
              <GooglePlacesAutocomplete
                apiKey={process.env.NEXT_PUBLIC_MAPS_API_KEY}
                selectProps={{
                  placeholder: "",
                  // defaultInputValue: userData?.address,
                  ...field,
                  theme: googleMapsInput.theme,
                  styles: googleMapsInput.styles,
                }}
              />
              {fieldState.error && (
                <div className="settingsInput__errText">
                  {inputStrings.requiredErrorMessage}
                </div>
              )}
            </>
          )}
          // onChange={([, data]) => data}
          name={inputStrings.id}
          control={control}
        />
      )}

      {type === "skills" && (
        <div className="settingsInput__wrapper">
          <Controller
            rules={{
              required: inputStrings.requiredErrorMessage,
            }}
            render={({ field: { onChange }, fieldState }) => (
              <Autocomplete
                multiple={existing && actDroner?.subscriptionLevel !== "free"}
                // defaultValue={userData?.skills}
                options={dcContent.skills.map((skill) => skill.name)}
                renderInput={(params) => (
                  <TextField
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    {...params}
                    variant="outlined"
                    className="muiCustomizedInput"
                  />
                )}
                onChange={(e, data) =>
                  onChange(Array.isArray(data) ? data : [data])
                }
              />
            )}
            // onChange={([, data]) => data}
            // defaultValue={userData?.skills}
            name={inputStrings.id}
            control={control}
          />

          <div className="settingsInput__wrapper--text">
            <Image
              src="/assets/arrow-down.png"
              alt="arrow down"
              width="16"
              height="10"
            />
          </div>
        </div>
      )}

      {type === "equipment" && (
        <div className="settingsInput__wrapper">
          <Controller
            render={({ field: { onChange } }) => (
              <Autocomplete
                freeSolo
                autoSelect
                multiple
                options={allEquipment.map((eq: any) => eq.name)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="muiCustomizedInput"
                  />
                )}
                onChange={(e, data) => onChange(data)}
              />
            )}
            name={inputStrings.id}
            control={control}
          />
          <div className="settingsInput__wrapper--text">
            <Image
              src="/assets/arrow-down.png"
              alt="arrow down"
              width="16"
              height="10"
            />
          </div>
        </div>
      )}
    </div>
  );
}
